import { EntityLayout } from '@backstage/plugin-catalog';
import { Grid } from '@material-ui/core';
import React from 'react';
import { EntityOwnershipCard } from '@backstage/plugin-org';
import { EntityUserProfileCard } from '../../../components/catalog/EntityUserProfileCard';

const OverviewContent = () => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <EntityUserProfileCard />
      </Grid>
      <Grid item xs={12} md={6}>
        <EntityOwnershipCard />
      </Grid>
    </Grid>
  );
};

export const UserPage = () => {
  return (
    <EntityLayout UNSTABLE_contextMenuOptions={{ disableUnregister: 'hidden' }}>
      <EntityLayout.Route path="/" title="Overview">
        <OverviewContent />
      </EntityLayout.Route>
    </EntityLayout>
  );
};
